// Vue2常驻主体仅切换DOM挂载位置，不创建第二个会话实例，也不将DOM存入Vuex。
let target = null;
const listeners = new Set();
export function registerChatWorkbenchTarget(element) {
  target = element;
  listeners.forEach(listener => listener(target));
  return () => {
    if (target !== element) return;
    target = null;
    listeners.forEach(listener => listener(null));
  };
}
export function observeChatWorkbenchTarget(listener) {
  listeners.add(listener); listener(target);
  return () => listeners.delete(listener);
}
